import { CommercialIndustries } from "../../features/api-interfaces";
import { DivisionDict } from "../default-constants";

// 料率調整案件の調整内容のラベル
export const LABELS = {
  TITLE_REGISTER: "料率調整案件情報登録",
  TITLE_UPDATE: "料率調整案件情報更新",

  TABLE_ADJUSTMENT: "調整内容",

  MERCHANT_NAME: "加盟店名",
  SERVICE_NAME: "サービス名",
  CONTRACT_ROUTE: "契約形態",
  INCLUSION_MERCHANT: "包括加盟店",
  GW_COMPANY: "GW事業者",
  ANSWER_DATE: "回答日",
  APPLICATION_DATE: "申請日",
  ANSWER_RATE: "回答料率（%）",
  DESIRED_RATE: "希望料率",
  SALES: "売上高（億円）",
  ALL_STORE_NUMBER: "総店舗数",
  INSTALLED_SHOP_NUMBER: "導入店舗数",
  DOCOMO_DEFINED_INDUSTRY: "ドコモ定義業態",
  APPLIED_INDUSTRY: "申請業態",
  HANDLING_PRODUCTS: "取扱商材",
  RATE_CRITERIA: "料率提示条件",
  COST: "費用負担",
  COST_ADJUSTMENT_INFO: "費用負担調整情報",
  REMARK: "備考",
  LAST_UPDATER: "最終更新者:",
  LAST_UPDATING_TIME: "最終更新日時:",
  DIRECT_CONTRACT: "直接契約",
  INCLUSION_CONTRACT: "包括契約",
  YES: "あり",
  NO: "なし",
} as const;

// 入力補足のラベル
export const INPUT_LABELS = {
  GW_COMPANY_MESSAGE: "契約形態が直接契約の場合必須",
  INCLUSION_MERCHANT_MESSAGE: "契約形態が包括契約の場合必須",
  DOCOMO_DEFINED_INDUSTRY_MESSAGE: "契約形態が直接契約の場合必須",
  COST_ADJUSTMENT_INFO_MESSAGE: "費用負担がありの場合必須",
} as const;

// プレースホルダーの内容
export const PLACE_HOLDERS = {
  DATE: "YYYY/MM/DD",
  RATE: "2.20",
} as const;

// 変換後業態コード取得結果変換
export const getIndustryConversionsItems = (
  industries: CommercialIndustries[] | undefined
): DivisionDict[] => {
  if (industries !== undefined) {
    return industries.map((industries) => ({
      label: industries.industryName,
      value: industries.industryCode,
    }));
  }
  return [];
};
